import React from 'react';
import { m } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-114" data-mp="hv7hreobuv2d">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-flash/10 blur-3xl" aria-hidden="true" data-id="element-115" data-mp="mutw5rfw6hcr" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-116" data-mp="vmm0rli8iw9f">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-117" data-mp="10lypycwkwff6">
          <SectionTag icon="⚡" data-id="element-118" data-mp="15lbcewjjfkh8">Para profesores de Educación Física que quieren dejar de improvisar</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-extrabold uppercase leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-119" data-mp="1ak4p4mr037gc">
          Todo tu año de <span className="text-flash" data-id="element-120" data-mp="3vvarecsmkddt">EF</span> resuelto.
        </m.h1>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.14
      }} className="mt-3 font-heading text-sm font-bold uppercase tracking-wide text-muted sm:text-base" data-id="element-121" data-mp="3ruqv1bfvldsq">
          EDUCACIÓN FÍSICA FLASH: Sistema de Sesiones Listas para el Patio · Colección de 11 Tomos y 4 Bonos
        </m.p>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/nFA1cTzbjG7wRQP8kbGU4z/ChatGPT_Image_12_sept_2026__15_20_38-removebg-preview.webp" alt="EF-FLASH — colección de 11 tomos y 4 bonos" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-sm sm:max-w-md" data-id="element-122" data-mp="1b51u8hyd016k" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-123" data-mp="2qwvzkpc4g3ld">
          Abre el PDF de tu curso y lleva al patio una sesión organizada: objetivo, materiales, distribución
          del grupo, tiempos y esquema visual. EF-FLASH reúne 11 tomos, de 1º de Primaria a 1º de
          Bachillerato, con sesiones base, variantes desarrolladas, ajustes y rúbricas para preparar tu
          próxima clase con una guía concreta.
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="mt-7 flex flex-col items-center" data-id="element-124" data-mp="676kqcbf4hso">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-125" data-mp="1vnaav061j5vp">
            Quiero EF-FLASH por 17,99€
          </PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-126" data-mp="25cttq5tr6zqk">
            ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
          </p>
        </m.div>

        <m.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.34
      }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-127" data-mp="20kafr7r5m2l8">
          <div className="flex items-center gap-2" data-id="element-128" data-mp="2oamw970gt7nf">
            <StarRating data-id="element-129" data-mp="2o9bsv8axm1wu" />
            <span className="font-medium text-ink" data-id="element-130" data-mp="2jc3ap7ps9xvl">4,9/5</span>
            <span data-id="element-131" data-mp="2jaicn849fwsz">· +500 reseñas verificadas</span>
          </div>
          <div className="hidden h-4 w-px bg-slate-300 sm:block" aria-hidden="true" data-id="element-132" data-mp="tygaxfduxahe" />
          <div className="flex items-center gap-1.5 text-orange" data-id="element-133" data-mp="ozltagrmlryv">
            <ZapIcon size={16} className="fill-orange" data-id="element-134" data-mp="qfr5p9ocdfnz" />
            <span data-id="element-135" data-mp="qf7ndrus4p9f">47 profesores eligieron EF-FLASH hoy</span>
          </div>
        </m.div>
      </div>
    </header>;
}